import React from 'react';

import cx from 'classnames';

import Menu from 'components/Menu/Menu';

import styles from '../../Customers.module.scss';

const AddNewCustomerButton = ({ onAdd }) => (
  <Menu
    data={[
      {
        action: 'withAccount',
        title: 'With Account',
        icon: 'icon-user-check',
      },
      {
        action: 'withoutAccount',
        title: 'Without Account',
        icon: 'icon-user-remove',
      },
    ]}
    onAction={onAdd}
    renderCustomButton={({ open }) => (
      <div className='d-flex justify-content-end'>
        <button className={cx(styles.btnLeft, 'btn btn-primary text-light')} type='button' onClick={open}>
          <i className='icon-plus text-light me-2' />
          <span>Add New</span>
        </button>
        <button onClick={open} className={cx(styles.btnRight, 'btn btn-primary px-2')} type='button'>
          <i className='icon-chevron-bottom text-light' />
        </button>
      </div>
    )}
    iconSize='md'
    style={{ width: '220px' }}
    icon='icon-chevron-bottom'
    iconColor='text-light'
  />
);

export default AddNewCustomerButton;
